import React from 'react';
import { string } from 'prop-types';

const BookmarkIcon = ({
  color = 'sixth-color',
  fontSize = 'var(--base-medium)',
  className = ''
}) => (
  <span
    style={{
      color: `var(--${color})`,
      fontSize: fontSize
    }}
    className={`icon-ic_bookmark ${className}`}
  />
);

BookmarkIcon.propTypes = {
  color: string,
  fontSize: string,
  className: string
};

export default BookmarkIcon;
